import { request } from "../helpers/axios.new";
import AxiosConfigs from "../configs/axios";

const { REACT_APP_LINK_HOST: apiUrl } = AxiosConfigs;

// Dashboards use the SAME deployed API as the rest of the app
// (REACT_APP_LINK_HOST → api.gamemybiz.com). No special host — this behaves
// exactly like every other feature; it just needs the server redeployed with
// the /api/dashboard routes.
const base = `${apiUrl}/api/dashboard`;

// Absolute URLs so axios uses `dashHost` and ignores the shared baseURL.

export const GET_DASHBOARDS = () =>
  request({ url: base, method: "GET" });

// The boards a GIVEN player can open — not the same list as the caller's
// when the caller is an admin. Used before pinning a board to someone's home
// page. Admin-only on the server, except when asking about yourself.
export const GET_DASHBOARDS_FOR_USER = (userId) =>
  request({ url: `${base}/for-user/${userId}`, method: "GET" });

export const GET_DASHBOARD = (id) =>
  request({ url: `${base}/${id}`, method: "GET" });

export const CREATE_DASHBOARD = (data) =>
  request({ url: base, method: "POST", data });

export const UPDATE_DASHBOARD = (id, data) =>
  request({ url: `${base}/${id}`, method: "PUT", data });

export const SET_DEFAULT_DASHBOARD = (id) =>
  request({ url: `${base}/${id}/default`, method: "PUT" });

export const DELETE_DASHBOARD = (id) =>
  request({ url: `${base}/${id}`, method: "DELETE" });
